var runtime = require("../../../../../../build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"select":"_3HAtT"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._3HAtT{font-size:12px;width:125px;min-width:125px!important}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

